module.exports = __webpack_public_path__ + "img/tree-fire-flame-01-c.11c89496.png";